<!-- <div class="Loading" *ngIf="showLoading==true">

    <img id="" src="assets/img/762.gif" />
    <label>{{'Please Wait,Processing..'|translate }}</label>
</div> -->

<div class="Loading" *ngIf="showLoading==true">
    <div class="loader"></div>
    <!-- <img id="" src="assets/img/762.gif"   /> -->
    <label class="loaderlabel">Please wait while Processing....</label>
</div>
<div class="Reg">
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 hidden-xs hidden-sm">

            </div>

            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

                <!-- <div class="ImgSection">
                    <img src="assets/theme/en/images/Products.png" />
                </div> -->
                <!-- <div class="Motor animated slideInUp"> -->

                <div class="Motor animated fadeIn slow">

                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <div class="InsuredInformation Infomation">
                                <div class="Headertitle">
                                    <a class="already info" *ngIf="Insured"> {{'Insured Information'| translate}} </a>
                                    <a class="already" *ngIf="!Insured"> {{'Quotation Details'| translate}} </a>
                                    <!-- <a href="#/BeforeLogin/Login" class="otpfor">{{'Already have an Account? Click here'|translate}} </a> -->
                                    <!-- <a class="otpfor" *ngIf="Insured" (click)="Quote()"> {{'click here to get Quick quote'| translate}}</a>-->
                                    <a href="#/BeforeLogin/Login" style="text-decoration: underline;" class="otpfor alreadyhaveaccount_h">{{'Already have an Account? Click here'|translate}} </a>
                                    <a class="otpfor" *ngIf="!Insured" (click)="Inusred()">{{'Click here to Insured Information'| translate}} </a>
                                </div>

                                <!-- <div class="FormSection RegFormView" *ngIf="Insured"> -->
                                <div class="FormSection RegFormView">
                                    <!-- <div class="Clears"></div> -->
                                    <form #regForm="ngForm">
                                        <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="Iqama"> {{'ID number'|translate}}
                                                    </label>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <input type="text" numbersOnly required id="txtIqamaNo" minlength="10" maxlength="10" (change)="ClearMobileNo()" pattern="^[123]\d{9}$" name="txtIqamaNo" class="form-control" [(ngModel)]="regObj.InsuredIdNo" #txtIqamaNo="ngModel" placeholder="{{'Enter ID Number' | translate}}" autocomplete="off" [disabled]="isLockFields==true">
                                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Identification Required"></span>
                                                    <span *ngIf="txtIqamaNo.errors && (txtIqamaNo.dirty || txtIqamaNo.touched)" class="text-danger valid">
                                                        <p *ngIf="txtIqamaNo.errors.required"> {{'ID Number is required'|translate}}</p>
                                                        <p *ngIf="txtIqamaNo.errors.pattern && txtIqamaNo.invalid && txtIqamaNo.touched"> {{'ID Number Must start with 1 or 2 and must be 10 digits'|translate}}
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="Field" *ngIf="regObj.InsuredIdNo?.length==10">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

                                                    <label class="dob" *ngIf="regObj.InsuredIdNo?.startsWith('2')">{{'Date of Birth'|translate}}</label>
                                                    <label class="IDE" *ngIf="regObj.InsuredIdNo?.startsWith('1')">{{'Date of Birth Hijri'|translate}}</label>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <div class=" row dobfiled">

                                                        <div class="col-lg-3">
                                                            <input class="form-control" required numbersOnly maxlength="2" minlength="2" id="txtMM" name="txtMM" type="text" [(ngModel)]="MM" #txtMM="ngModel" placeholder="MM" [disabled]="isLockFields==true" [CustomMonthDirective]>
                                                            <span *ngIf="txtMM.errors && (txtMM.dirty || txtMM.touched)" class="text-danger valid">
                                                                <p *ngIf="txtMM.errors.required">{{'MM is required'|translate}}</p>
                                                                <p *ngIf="txtMM.errors.minlength">{{'MM Must be two digits'|translate}} </p>
                                                                <p *ngIf="txtMM.errors.CustomMonthDirective">{{'Invalid Month'|translate}} </p>
                                                            </span>
                                                        </div>
                                                        <div class="col-lg-3">

                                                            <input class="form-control" numbersOnly maxlength="4" minlength="4" required id="txtYY" name="txtYY" type="text" [(ngModel)]="YYYY" #txtYY="ngModel" placeholder="YYYY" [disabled]="isLockFields==true" YearCustomValidation={{regObj.InsuredIdNo}}>
                                                            <span *ngIf="txtYY.errors && (txtYY.dirty || txtYY.touched)" class="text-danger valid">
                                                                <p *ngIf="txtYY.errors.required">{{'YYYY is required'|translate}}</p>
                                                                <p *ngIf="txtYY.errors.minlength"> {{'YYYY Must be Four digits'|translate}} </p>
                                                                <p *ngIf="txtYY.errors.YearCustomValidation">{{ 'Invalid Year' | translate }}</p>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6">



                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="Email">{{'Email Id'|translate}}</label>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <input type="email" id="txtEmail" required name="txtEmail" autocomplete="off" [(ngModel)]="regObj.EmailId" class="form-control" #txtEmail="ngModel" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?!\.)(?!.*?\.\.)(?!.*\.$)[a-zA-Z.]{2,10}$" placeholder="{{'Enter Email ID'|translate}}" [disabled]="isLockFields==true">
                                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Email Id Required"></span>
                                                    <span *ngIf="txtEmail.errors && (txtEmail.dirty || txtEmail.touched)" class="text-danger valid">
                                                        <p *ngIf="txtEmail.errors.required">{{'Email is required'|translate}}</p>
                                                        <p *ngIf="txtEmail.errors.pattern && txtEmail.invalid && txtEmail.touched ">{{'Invalid Email Format'|translate}} </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!txtIqamaNo.errors" class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="Mobile">{{'Mobile'|translate}}</label>
                                                </div>
                                                <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 PaddLeft">
                                                    <input placeholder="+966" type="text" class="MbleNumberPrfix" disabled />
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">

                                                    <input type="text" id="txtMobile"  numbersOnly (change)="YakeenMobileNoVerify()" autocomplete="off" required maxlength=9 minlength="9" name="txtMobile" pattern="^5\d{8}$" [(ngModel)]="regObj.MobileNo" class="form-control Mobiles MBLE" #txtMobile="ngModel" placeholder="5XXXXXXXX" [disabled]="isLockFields==true">
                                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Mobile Number Required"></span>
                                                    <span *ngIf="txtMobile.errors && (txtMobile.dirty || txtMobile.touched)" class="text-danger valid">
                                                        <p *ngIf="txtMobile.errors.required">{{'Mobile No is required'|translate}}</p>
                                                        <p *ngIf="txtMobile.errors.pattern && txtMobile.invalid && txtMobile.touched ">{{'Mobile Number must be like (05XXXXXXXX)'|translate}} </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Cptcha Start -->
                                        <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="Captcha">{{'Captcha'|translate}}</label>
                                                </div>


                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <table class="captchatable">

                                                        <tr>
                                                            <td>
                                                                <div style=" border: 1px solid #ccc; height: 35px;" id="captcha" name="captcha" #captcha>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <button style="background: transparent; border: unset;" type="button" title="Reload" (click)="CreateCaptcha()">
                                                                    <i class="fa fa-refresh" style="color: #004085;" aria-hidden="true"></i>
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <input type="text" id="txtCaptcha" numbersOnly autocomplete="off" required maxlength=6 minlength="4" name="txtCaptcha" [(ngModel)]="EnteredCaptchaCode" class="form-control Mobiles" #txtCaptcha="ngModel" placeholder="{{'Enter Captcha'|translate}}" [disabled]="isLockFields==true">

                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Captcha Required"></span>
                                                                <span *ngIf="txtCaptcha.errors && (txtCaptcha.dirty || txtCaptcha.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtCaptcha.errors.required">{{'Captcha is required'|translate}}</p>
                                                                    <!-- <p *ngIf="txtCaptcha.invalid && txtCaptcha.touched">{{'Captcha is required'|translate}} </p> -->
                                                                </span>
                                                            </td>

                                                        </tr>

                                                    </table>


                                                </div>
                                            </div>

                                        </div>
                                        <!-- Cptcha End -->

                                        <div class="Field">
                                            <!-- <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                            </div> -->
                                            <!-- <div class="col-lg-10 col-md-10 col-sm-6 col-xs-12"> -->

                                            <!-- <div class="row AcceptConditions">
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 check">
                                                    <input type="checkbox" id="txtConditions" name="txtConditions" required class="agreeTerms" [(ngModel)]="isCheckAgreed" style=" zoom: 1.5;" />
                                                </div>
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 iagree">
                                                    <p class="Policyterms" style="font-weight:bold;">{{'I Agreed to Policy Terms and Conditions' | translate}}</p>
                                                </div>
                                            </div> -->

                                            <div class="row AcceptConditions">
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 check">
                                                    <input type="checkbox" id="txtConditions" name="txtConditions" required class="agreeTerms" [(ngModel)]="isCheckAgreed" style=" zoom: 1.5;" />
                                                </div>
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 iagree">
                                                    <p class="Policyterms" style="font-weight:bold;">{{'I grant Gulf General Insurance the authorization to collect and utilize my personal and vehicle information from relevant authorities to provide the requested service and after-sales support' | translate}}</p>
                                                </div>
                                            </div>
                                            <div class="row AcceptConditions">
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 check">
                                                    <input type="checkbox" id="txtConditions2" name="txtConditions2" required class="agreeTerms" [(ngModel)]="isCheckAgreed2" style=" zoom: 1.5;" />
                                                </div>
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 iagree">
                                                    <a href="https://www.ggi-sa.com/ar/page/Privacy_Policy" style="font-weight:bold;text-decoration: underline;color: #337ab7;" class="Privacyterms" target="_blank"> {{ 'I accept the Gulf General Insurance privacy policy and notice' | translate }}</a>

                                                </div>
                                            </div>
                                            <div class="row AcceptConditions">
                                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 check">
                                                    <input type="checkbox" id="txtConditions3" name="txtConditions3" class="agreeTerms" [(ngModel)]="isCheckAgreed3" style=" zoom: 1.5;" />
                                                </div>
                                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 iagree">
                                                    <p class="Policyterms" style="font-weight:bold;">{{'I would like to receive marketing and awareness through SMS and Email' | translate}}</p>
                                                </div>
                                            </div>


                                        </div>

                                        <div class="Field">
                                            <div class="Actionsection">
                                                <div class="Actions">
                                                    <div class="btn-group">
                                                        <!-- <button type="button" class="btn btn-primary btns" [attr.disabled]="PolicyTrue?'true':null" (click)="Back()">Back</button> -->
                                                        <!-- <button type="button" *ngIf="!this.showLoading" class="btn btn-primary  btns procced" [disabled]="(!regForm.valid || showOTP)" -->
                                                        <button type="button" *ngIf="!this.showLoading" class="MiddleButton" [disabled]="(!regForm.valid || showOTP)" (click)="AddReg()">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            {{'Proceed'|translate}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <div class="Field" *ngIf="showOTP">
                                        <div class="OTPForm" >
                                            <div class="Field">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                        <label class="Verifi">{{'Verification Code'|translate}}</label>
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">


                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                                <input type="text" [(ngModel)]="otpReq.OTP" class="form-control" maxlength="6">
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                                <button type="button" class="btn btn-primary Resend" (click)="ResendOTP()" *ngIf="isResendShow">{{'Resend'|translate}}</button>
                                                                <button type="button" class="btn btn-primary Resend" (click)="verifyOTP()" [disabled]="(otpReq.OTP?.length==0 || otpReq.OTP==null )">{{'Verify'|translate}}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="Field" *ngIf="this.isShowTimer">
                                        <span class="quotelink">{{'You can Resend OTP in '}} {{ this.CurrentTime }} {{'Seconds'}}</span>
                                    </div>


                                    <div class="Field">

                                    </div>


                                </div>

                                <div class="QuoteForm" *ngIf="!Insured">

                                    <div class="FormSection">
                                        <form #f1="ngForm" novalidate>


                                            <div class="Field">
                                                <div class="row quotField">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Email"> {{'Mobile Number'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <input type="text" numbersOnly maxlength="10" required class="form-control" name="txtQuoteMobile" id="txtQuoteMobile" pattern="^05\d{8}$" [(ngModel)]="quoteReq.MobileNo" #txtQuoteMobile="ngModel">
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Mobile Number Required"></span>
                                                                <span *ngIf="txtQuoteMobile.errors && (txtQuoteMobile.dirty || txtQuoteMobile.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtQuoteMobile.errors?.required"> {{'Mobile Number is required'|translate}}</p>
                                                                    <p *ngIf="txtQuoteMobile.errors?.pattern">{{'Mobile Number must start with 05'|translate}}</p>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Mobile">{{'Make'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <select id="txtMake" required name="txtMake" class="form-control" name="txtQMake" id="txtQMake" [(ngModel)]="quoteReq.Make" #txtQMake="ngModel" (change)="getMakes(quoteReq.Make)">
                                                                    <option value="" selected>--{{'Select Make'|translate}}--</option>
                                                                    <option *ngFor="let m of quoteBind.makeList" [value]="m.MakeCode">
                                                                        {{Lng=="en"?m.MakeDescEn:m.MakeDescAr}}
                                                                    </option>
                                                                </select>
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Make Required"></span>
                                                                <span *ngIf="txtQMake.errors && (txtQMake.dirty || txtQMake.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtQMake.errors?.required"> {{'Make is required'|translate}}</p>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div class="Field">
                                                <div class="row quotField">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Email">{{'Model'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <select id="txtQModel" name="txtQModel" required class="form-control" [(ngModel)]="quoteReq.Model" #txtQModel="ngModel">
                                                                    <option value="">--{{'Select Model'|translate}}--</option>
                                                                    <option *ngFor="let model of fiteredModels" [value]="model.ModelCode">
                                                                        {{Lng=="en"?model.ModelDescEn:model.ModelDescAr}}
                                                                    </option>
                                                                </select>
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Model Required"></span>
                                                                <span *ngIf="txtQModel.errors && (txtQModel.dirty || txtQModel.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtQModel.errors?.required">{{'Model is required'|translate}}</p>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Email">{{'Use Of Vehicle'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <select id="txtUsage" name="txtUsage" required class="form-control" name="txtUsage" id="txtUsage" [(ngModel)]="quoteReq.VehcileUsage" #txtUsage="ngModel">
                                                                    <option value="">--{{'select usage of vehicle'|translate}}--</option>
                                                                    <option *ngFor="let usage of quoteBind.usageList" [value]="usage.VehUsagecode">
                                                                        {{Lng=="en"? usage.VehUsage_DescEn: usage.Vehusage_DescAr}}
                                                                    </option>
                                                                </select>
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="USE OF Vehicle"></span>
                                                                <span *ngIf="txtUsage.errors && (txtUsage.dirty || txtUsage.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtUsage.errors?.required">{{'Usage of Vehicle is required'|translate}}</p>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>






                                            <div class="Field">
                                                <div class="row quotField">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Mobile">{{'Deductable'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <select id="txtDeductable" name="txtDeductable" required class="form-control" [(ngModel)]="quoteReq.DEDUCTIBLE_CODE" #txtDeductable="ngModel">
                                                                    <option value="">--{{'Select Deductable'|translate}}--</option>
                                                                    <option *ngFor="let deduct of quoteBind.deductableList" [value]="deduct.DeductableCode">
                                                                        {{Lng=="en"? deduct.DeductableDescEn:deduct.DeductableDescAr}}
                                                                    </option>
                                                                </select>
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Region Required"></span>
                                                                <span *ngIf="txtDeductable.errors && (txtDeductable.dirty || txtDeductable.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtDeductable.errors?.required">{{'Deductable is required'|translate}}</p>


                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <label class="Email">{{'Model Year'|translate}}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <input type="text" name="txtVehAge" id="txtVehAge" required numbersOnly class="form-control" [(ngModel)]="quoteReq.VehcileAge" #txtVehAge="ngModel" maxlength="4" minlength="4">
                                                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Model Required"></span>
                                                                <span *ngIf="txtVehAge.errors && (txtVehAge.dirty || txtVehAge.touched)" class="text-danger valid">
                                                                    <p *ngIf="txtVehAge.errors?.required">{{'Model Year'|translate}}</p>
                                                                    <p *ngIf="txtVehAge.errors?.maxlength">{{'Year Format must be YYYY'|translate}}</p>
                                                                    <p *ngIf="txtVehAge.errors?.minlength">{{'Year Format must be YYYY'|translate}}</p>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div class="row" *ngIf="QuoteStatus">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                    <button class="btn btn-primary" name="btnQuote" id="btnQuote" [disabled]="!f1.valid" (click)="generateQuote(f1.valid)">{{'Get Quote'|translate}}</button>
                                                </div>
                                            </div>


                                            <div class="Field" *ngIf="quoteRes.st.StatusCode=='S'">
                                                <div class="QuotePremium">

                                                    <div class="row">

                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <div class="premium">
                                                                <span class="premiumType">
                                                                    {{'TPL Pemium starts from :'|translate}}
                                                                </span>
                                                                <span class="PremiumAmount" *ngIf="quoteRes.TPLPremiumExists==true">
                                                                    {{quoteRes.TPLPremium | number : '1.2-2'}}(SAR)
                                                                </span>

                                                                <span class="PremNot" *ngIf="quoteRes.TPLPremiumExists==false">
                                                                    {{'Premium not defined for selected Model'|translate}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <div class="premium">
                                                                <span class="premiumType">
                                                                    {{'Comprehensive premiumm starts from : '|translate}}
                                                                </span>
                                                                <span class="PremiumAmount" *ngIf="quoteRes.CompPremiumExists==true">
                                                                    {{quoteRes.CompPremium | number : '1.2-2'}}(SAR)
                                                                </span>

                                                                <span class="PremNot" *ngIf="quoteRes.CompPremiumExists==false">
                                                                    {{'Premium not defined for selected Model'|translate}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="Clears"></div>

                                                        <div class="buttonactions" *ngIf="(quoteRes.st.StatusCode=='S')">
                                                            <button type="button" (click)="Inusred()" class="btn btn-primary" [disabled]="quoteRes.TPLPremiumExists==false && quoteRes.CompPremiumExists==false">{{'Buy Now'|translate}}</button>
                                                            <button type="reset" (click)="ClearQuote();" class="btn btn-primary">{{'Clear'|translate }}</button>
                                                        </div>


                                                    </div>


                                                </div>

                                            </div>

                                        </form>
                                    </div>





                                </div>




                                <!-- Second Form Section -->





                                <!-- Button Actions -->

                                <div class="Actionsection" *ngIf=false>
                                    <div class="Actions">
                                        <div class="btn-group">



                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="Footer">
                        <a style="text-decoration: underline;"  (click)="GoToClaimStatus()">{{'Check Claim Status'|translate}} </a>

                        <div class="tooltip-wrapper">
                            <button class="UnSubBtn" (click)="goToUnsubscribe()">
                                {{ 'Unsubscribe' | translate }}
                            </button>
                    
                            <span class="tooltip-text">
                                {{ 'UNSUBSCRIBE_HOVER_TEXT' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>


<div class="modal fade" tabindex="1" role="dialog" id="ProductAttachModal" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" style="width: 90%;margin-left: auto;margin-right: auto;margin-top:87px;">
        <div class="modal-content" style="padding-bottom: 10px;">

            <div class="modal-header">
                <div class="modalContent PaymentForm">
                    <h5  class="modal-title">{{'Claim Status'| translate}}</h5>
                    
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClaimModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>

            <div class="modal-body">
                <div class="wrapper">

                    <label style="padding: 5px;">{{'Claim Status' | translate}}</label>
                    <div class="row searchRow">
                
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <label for="">{{""}}</label>
                            <select class="form-control" id="ddlSearch" [(ngModel)]="SerachByValue" #ddlSearch="ngModel" (ngModelChange)="ClearText()">
                                <option value="">--{{ 'Select' | translate }}--</option>
                                <option value="POLICY_NO">{{ 'POLICY NO' | translate }}</option>
                                <option value="SEQUENCE_NO">{{ 'SEQUENCE NO' | translate }}</option>
                                <option value="CUSTOM_ID">{{ 'CUSTOM ID' | translate }}</option>
                                <option value="CHASSIS_NO">{{ 'CHASSIS NO' | translate }}</option>
                                <option value="INSURED_MOBILE_NO">{{ 'INSURED MOBILE NO' | translate }}</option>
                                <option value="INSURED_ID">{{ 'INSURED ID' | translate }}</option>
                                <option value="THIRD_PARTY_ID">{{ 'THIRD PARTY ID' | translate }}</option>
                                <option value="THIRD_PARTY_MOBILE_NO">{{ 'THIRD PARTY MOBILE NO' | translate }}</option>
                                <option value="THIRD_PARTY_PLATE_NO">{{ 'THIRD PARTY PLATE NO' | translate }}</option>
                                <option value="NAJM_CASE_NUMBER">{{ 'NAJM CASE NUMBER' | translate }}</option>
                                <option value="CLAIM_NO">{{ 'CLAIM NO' | translate }}</option>
                                <option value="THIRD_PARTY_SEQUENCE_NO">{{ 'THIRD PARTY SEQUENCE NO' | translate }}</option>
                            </select>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <label for="">{{"" | translate}}</label>
                            <input class="form-control" type="text" id="txtSearch" *ngIf="SerachByValue!=''" name="txtSearch" [(ngModel)]="SearchTextValue" #txtSearch="ngModel">
                        </div>

                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label for="">{{""}}</label>
                            <button class="btn btn-primary" style="margin-top: 19px;" (click)="GetCalimStatus()">{{'Search Claim'|translate}}</button>
                        </div>
                    </div>
                
                
                
                </div>
                
                <!-- Claim status Start -->
                <div class="overlay" *ngIf="ShowClaimStatus">
                    <div class="popup">
                        <div class="modalcard">
                            <p class="modaltitle">{{'Claim Status'|translate}}
                                <span style="color: aliceblue;font-weight: 500;cursor: pointer;" (click)="HideClaimStatus()">X</span>
                            </p>
                
                
                            <table class="table table-hover" id="PolicyList">
                                <thead style=" color: black;">
                                    <tr>
                                        <th scope="col">{{'Sno'| translate}}</th>
                                        <th scope="col">{{'ClaimNo'|translate}}</th>
                                        <th scope="col">{{'Action'|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let obj of ClaimStatusRes.ClaimNoList; index as i">
                                        <th scope="row">{{i+1}}</th>
                                        <td><a class="third after fw700 TxtEng" (click)="ShowClaimsStatus(obj)">{{obj.CLAIM_NUMBER}}</a></td>
                                        <td><a style="cursor: pointer;" data-toggle="tooltip" title="{{'View Claim'|translate}}" (click)="ShowClaimsStatus(obj)"><i class="fa fa-eye fa-lg"></i></a></td>
                                    </tr>
                                </tbody>
                            </table>
                
                
                
                            <div class="cardcontent" style="width: 100%;" *ngIf="CurrentClaimStatus !=null && CurrentClaimStatus.length>0">

                                <div class="wrapper" *ngIf="Lang=='en'">
                                    <ul class="StepProgressEnglish">
                                        <li class="StepProgressEnglish-item is-done" *ngFor="let obj of CurrentClaimStatus">
                                            <strong>{{obj.STATUS | translate}}
                                                <a *ngIf="obj.STATUS=='Document Incomplete'"  (click)="CheckClaimDocument(obj)" style="text-decoration:underline;gap: 5px;">{{'Check Document'| translate}}</a>
                                            </strong>
                                            {{obj.StatusDesc | translate}}
                                        </li>
                                    </ul>
                                    <div class="cardcontent" style="width: 100%;" *ngIf="TempDocumentList !=null && TempDocumentList.length>0">
         
                                        <strong>{{'Document Incomplete Are :' | translate}}</strong>
                                        <li *ngFor="let obj of TempDocumentList">
                                            {{Lng=="en"?obj.DOC_NAME_EN:obj.DOC_NAME_BL}}
                                        </li>
                                            
                                    </div>
                                </div>
                
                                <div class="wrapper" *ngIf="Lang=='ar'">
                                    <ul class="StepProgressArabic">
                                        <li class="StepProgressArabic-item is-done" *ngFor="let obj of CurrentClaimStatus">
                                            <strong>{{obj.STATUS | translate}}
                                                <a *ngIf="obj.STATUS=='Document Incomplete'" (click)="CheckClaimDocument(obj)" style="text-decoration:underline;gap: 5px;">{{'Check Document'| translate}}</a>
                                            </strong>
                                            {{obj.StatusDesc | translate}}
                                        </li>
                                    </ul>
                                    <div class="cardcontent" style="width: 100%;" *ngIf="TempDocumentList !=null && TempDocumentList.length>0">
         
                                        <strong>{{'Document Incomplete Are :' | translate}}</strong>
                                        <li *ngFor="let obj of TempDocumentList">
                                            {{Lng=="en"?obj.DOC_NAME_EN:obj.DOC_NAME_BL}}
                                        </li>
                                            
                                    </div>
                                </div>

                                
                
                            </div>
                
                        </div>
                    </div>
                </div>
                <!-- Claim status end -->
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/NewReg/NewReg.html